class NewsletterPopup extends ModalDialog {
  constructor() {
    super();

    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie('newsletter-closed');
    this.subscribed = getCookie('newsletter-subscribed');
    this.form = this.querySelector('.js-form');

    this.ageVerificationPopup = document.querySelector(
      'age-verification-popup'
    );

    if (this.form) {
      this.form.addEventListener(
        'submit',
        this.onSubscribe.bind(this)
      );
    }
  }

  connectedCallback() {
    /*
     * بعد تسجيل الإيميل وإعادة تحميل الصفحة:
     * افتح الـPopup مباشرة لعرض رسالة النجاح داخله.
     */
    if (
      sessionStorage.getItem('newsletter-just-subscribed') === 'true'
    ) {
      sessionStorage.removeItem('newsletter-just-subscribed');

      setCookie('newsletter-subscribed', 'true');

      setTimeout(() => {
        this.show();
      }, 100);

      return;
    }

    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === 'true') {
        this.show();
      }

      return;
    }

    if (this.ageVerificationPopup) {
      let prevClassState = this.classList.contains(
        'newsletter-popup-is-hidden'
      );

      const newsletterPopup = this;

      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'class') {
            const currentClassState =
              mutation.target.classList.contains(
                'newsletter-popup-is-hidden'
              );

            if (prevClassState !== currentClassState) {
              prevClassState = currentClassState;

              if (!currentClassState) {
                setTimeout(() => {
                  if (
                    newsletterPopup.closed !== null ||
                    newsletterPopup.subscribed !== null
                  ) {
                    return;
                  }

                  newsletterPopup.show();
                }, newsletterPopup.delay);
              }
            }
          }
        });
      });

      observer.observe(this, { attributes: true });
    } else {
      setTimeout(() => {
        if (this.closed !== null || this.subscribed !== null) {
          return;
        }

        this.show();
      }, this.delay);
    }
  }

  hide() {
    super.hide();
    setCookie('newsletter-closed', 'true');
  }

  onSubscribe() {
    /*
     * لا تسكّر الـPopup هنا.
     * خزّن إشارة مؤقتة حتى نفتحه بعد إعادة تحميل الصفحة.
     */
    sessionStorage.setItem(
      'newsletter-just-subscribed',
      'true'
    );
  }
}

customElements.define('newsletter-popup', NewsletterPopup);